import { IAffairAttachExtVideoApi, IExtVideoInfo, IVideoResolveFbWatch, TAttachmentKindExtVideo } from "@api/affair.int";
import { Box, BoxProps, Divider, FormControl, FormLabel, Img, Input, InputGroup, InputLeftAddon, InputLeftElement, Progress } from "@chakra-ui/react";
import { useVVApi } from "components/api";
import { useVVStore } from "components/store";
import { RemoteButton } from "components/RemoteButton";
import { useContext, useEffect, useState } from "react";
import { MdVideocam } from "react-icons/md";
import { AffairContext } from "./Affair";
import { VizvButtonPrimary, VizvCardActionStrip, VizvCardContent } from "components/vizvComponents";
import { DeepErrorBox } from "components/misc";



export function AffairVideoUpload() {
	const ctx = useContext(AffairContext);

	const api = useVVApi();
	const addAffairItems = useVVStore(state => state.addAffairItems);

	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState('');

	const [origUrl, setOrigUrl] = useState('');
	const [kind, setKind] = useState<TAttachmentKindExtVideo | ''>('');
	const [videoId, setVideoId] = useState('');
	const [videoInfo, setVideoInfo] = useState<IExtVideoInfo>({});

	const clear = () => {
		setKind('');
		setVideoId('');
		setVideoInfo({});
	}

	useEffect(() => {
		if (!origUrl)
			return;
		clear();
		setError('');

		(async () => {
			setIsLoading(true);
			try {

				const url = new URL(origUrl);
				const allowedHosts = ['youtu.be', 'youtube.com', 'fb.watch', 'facebook.com', 'tiktok.com'];
				if (!allowedHosts.find(h => url.hostname.endsWith(h)))
					throw `Not allowed host: ${url.hostname}`;

				// ========================================================================== YOUTUBE ==========================
				if (url.hostname.endsWith('youtu.be')) {
					const pathArr = url.pathname.split('/').filter(p => !!p);
					let videoId = pathArr[0] || '';
					let videoKind: TAttachmentKindExtVideo = 'youtube_video';
					if (videoId === 'shorts') {
						videoId = pathArr[1];
						videoKind = 'youtube_shorts';
						if (!videoId)
							throw `No youtu.be/shorts videoId`;
					} else if (!videoId) {
						throw `No youtu.be videoId`;
					}
					let resp = await fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`);
					if (resp.status >= 400)
						throw `Nem találom a videót: ${resp.status} ${resp.statusText}`;
					setVideoId(videoId);
					setKind(videoKind);
				} else if (url.hostname.endsWith('youtube.com')) {
					const pathArr = url.pathname.split('/').filter(p => !!p);
					let videoId = '';
					let videoKind: TAttachmentKindExtVideo | '' = '';
					if (pathArr[0] === 'shorts') {
						videoId = pathArr[1];
						if (!videoId)
							return setError('No youtube shorts videoId');
						videoKind = 'youtube_shorts';
					} else {
						videoId = url.searchParams.get('v') || '';
						if (!videoId)
							return setError('No youtube videoId');
						videoKind = 'youtube_video'
					}
					let resp = await fetch(`https://www.youtube.com/oembed?url=https://www.youtube.com/watch?v=${videoId}&format=json`);
					if (resp.status >= 400)
						throw `Nem találom a videót: ${resp.status} ${resp.statusText}`;
					setVideoId(videoId);
					setKind(videoKind);

					// ========================================================================== FACBOOK ==========================
				} else if (url.hostname.endsWith('fb.watch')) { // --------------- fb.watch ----------------------
					let resp = await api.fetch<IVideoResolveFbWatch>({ url: '/affair/video-resolve/fb-watch', method: 'POST', payload: { origUrl } });
					/*let respx = await fetch('http://localhost:3001/resolve-fb-watch?url=' + encodeURIComponent(origUrl));
					let resp = await respx.json();*/
					const videoId = resp.resolvedUrl as string;
					setVideoId(videoId);
					setKind('facebook_video')

				} else if (url.hostname.endsWith('facebook.com')) {
					const pathArr = url.pathname.split('/').filter(p => !!p);
					if (pathArr.length >= 2 && pathArr[1] === 'videos') {    // --------------- reels ----------------------
						const videoId = pathArr[2] || '';
						if (!videoId)
							throw 'No facebook /videos videoId';
						setKind('facebook_video');
						setVideoId(origUrl);
					} else if (pathArr[0] === 'reel') {    // --------------- reels ----------------------
						const videoId = pathArr[1] || '';
						if (!videoId)
							throw 'No facebook reel videoId';
						setKind('facebook_reels');
						setVideoId(origUrl);
					} else if (pathArr[0] === 'share' && pathArr[1] === 'v') {  // --------------- share link ----------------------
						const videoId = pathArr[2] || '';
						if (!videoId)
							throw 'No facebook share videoId';
						/*FB.api('506800955458974', { fields: 'format'}, function (response) {
							console.log('FB RESPONSE');
							console.log(response);
						});*/
						setKind('facebook_video');
						setVideoId(videoId);
					} else if (pathArr[0] === 'share' && pathArr[1] === 'r') {  // --------------- share reels link ----------------------
						let videoId = pathArr[2] || '';
						if (!videoId)
							throw 'No facebook share videoId';
						/*let respx = await fetch('http://localhost:3001/resolve-fb-watch?url=' + encodeURIComponent(origUrl));
						let resp = await respx.json();*/
						let resp = await api.fetch<IVideoResolveFbWatch>({ url: '/affair/video-resolve/fb-watch', method: 'POST', payload: { origUrl } });
						videoId = resp.resolvedUrl as string;
						setKind('facebook_reels');
						setVideoId(videoId);
					} else if (pathArr[0] === 'watch') {  // --------------- share link ----------------------
						const videoId = url.searchParams.get('v') || '';
						if (!videoId)
							throw 'No facebook watch videoId';
						setKind('facebook_video');
						setVideoId(origUrl);
					} else {
						throw `Ismeretlen facebook cím formátum: ${url.pathname}`;
					}

				} else if (url.hostname.endsWith('tiktok.com')) {// ========================================================================== TIKTOK ==========================
					//https://www.tiktok.com/@szeretlekmagyarorszag.hu/video/7479006358830910743?is_from_webapp=1&sender_device=pc
					const pathArr = url.pathname.split('/').filter(p => !!p);
					const videoId = pathArr.pop();
					if (pathArr.pop() === 'video' && videoId) {

						let resp = await fetch(`https://www.tiktok.com/oembed?url=${origUrl}`);
						if (resp.status >= 400)
							throw `Nem találom a tiktok videót: ${resp.status} ${resp.statusText}`;
						const json = await resp.json();


						setKind('tiktok');
						setVideoId(json.embed_product_id);
					} else {
						throw `Ismeretlen tiktok cím formátum: ${url.pathname}`;
					}

				} else {
					throw `Unknown video site: "${url.hostname}"`;
				}
			} catch (ex) {
				setError('' + ex);
			} finally {
				setIsLoading(false);
			}



		})();

		//setImg(`https://img.youtube.com/vi/${videoId}/0.jpg`)
		//uploadVideo(videoId);


		//setIsLoading(true);
	}, [origUrl]);

	const uploadVideo = async () => {
		if (!ctx.affair || !kind)
			return;
		setIsLoading(true);
		try {
			const resp = await api.fetch<IAffairAttachExtVideoApi>({
				url: "/affair/:affairKey/attachment/ext-video", method: 'POST',
				params: {
					affairKey: ctx.affair.affairKey
				},
				payload: {
					kind, origUrl, videoId, videoInfo
				}
			});
			console.log('----->', resp);
			// refresh in store, and refresh here...
			addAffairItems([resp.affair]);
			ctx.setAffair(resp.affair, resp.newAttachmentKey);

		} catch (ex) {
			setError('' + ex);
		} finally {
			setIsLoading(false);
		}
	}




	return <VizvCardContent flex={1}>
		{isLoading && <Progress isIndeterminate />}
		<FormControl>
			<FormLabel>Másold ide a videó címét:</FormLabel>
			<InputGroup>
				<InputLeftAddon>https://</InputLeftAddon>
				<Input value={origUrl} onChange={e => setOrigUrl(e.target.value)} isDisabled={isLoading} />
			</InputGroup>
		</FormControl>
		{/*<Divider />
        <Box>{kind} | {(videoId || '').substring(0, 30)}...</Box>
        <Divider />*/}
		<DeepErrorBox error={error} />
		{kind && <VVideoPlayer kind={kind} videoId={videoId} />}

		{kind && videoId && <VizvCardActionStrip>
			<VizvButtonPrimary ml='auto' size='lg' isLoading={isLoading} onClick={uploadVideo}>Csatolom a videót az esethez</VizvButtonPrimary>
		</VizvCardActionStrip>}
	</VizvCardContent>
}



export interface VVideoPlayerProps extends BoxProps {
	kind: TAttachmentKindExtVideo;
	videoId: string;
}


export function VVideoPlayer({ kind, videoId, ...rest }: VVideoPlayerProps) {
	return <Box w='100%' h='100%' display='flex' flexDir='column' alignItems='center' justifyContent='center' gap={6} pt={2} >
		{kind === 'tiktok' && <Box
			width="100%" height='500' position='relative'
		><iframe
			//top='0'
			//left='0'
			width="100%"
			height="100%"
			//position="absolute"
			//border='0'
			src={`https://www.tiktok.com/embed/${videoId}`}
			//className={iframe''
			allowFullScreen
			scrolling="no"
			allow="encrypted-media;"
		></iframe></Box>}


		{/*kind === 'tiktok' && <><blockquote className="tiktok-embed"
        //cite="https://www.tiktok.com/@retraaaaaaa/video/7478707228833303830" 
        data-video-id={videoId}
        style={{ maxWidth: '605px', minWidth: '325px' }} ></blockquote></>}
    {(false && kind === 'facebook_video') && <iframe
        src={`https://www.facebook.com/video/embed?video_id=${videoId}?width=300&height=500`}
        frameBorder="0"></iframe>*/}
		{(kind === 'facebook_video' || kind === 'facebook_reels') && <>
			<iframe
				src={`https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(videoId)}&show_text=false&width=400&height=400&t=0`}
				width="400" height="400" style={{ border: 'none', overflow: 'hidden' }}
				scrolling="no" frameBorder="0" allowFullScreen allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
			></iframe></>}
		{(kind === 'youtube_video' || kind === 'youtube_shorts') &&
			<iframe width="560" height="315"
				src={`https://www.youtube.com/embed/${videoId}`}
				title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
		}

	</Box>
}